import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { ApiService } from "./api.service";
import { SettingsService } from "./settings.service";
import { take } from "rxjs";
import { DialogService } from "./dialog.service";
import { ToastService } from "./toast.service";
// import { APIResponse } from "shared/models/api-response";
import { DashboardApiService } from "./api/dashboard.api.service";
import { APIResponse } from "shared/models/api-response";
import { ObjectUtils } from "shared/utils/object.utils";
import { Router } from "@angular/router";
import { DateTime } from 'luxon';
import { Utils } from "shared/utils/utils";

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  constructor(
    private _authService: AuthService,
    private _apiService: ApiService,
    private _settingsService: SettingsService,
    private _dialogService:DialogService,
    private _toastService:ToastService,
    private _dashboardApiService:DashboardApiService,
    private _router: Router
  )  {

  }

  initializeApp() {
    return new Promise<void>((resolve, reject) => {

      if (!this._authService.isLoggedIn()) {
        resolve();
        return;
      }

      this._apiService.getUserSettings().subscribe({

        next: async (response:APIResponse) => {

          console.warn("Intialize platform");

          if(response.success == false) { 
            resolve();

            setTimeout(()=> {
              this._toastService.warning(response.message)
              this._authService.logout({muted: true})
            },3000)
            
            return
          }
          this._checkPremiumTime(response)
          // Set user role
          localStorage.setItem('role',response.data.user.role);
          // Update user settings
          await this._settingsService.updateUserSettings(response.data);
          this._settingsService.startPolling();

          this._dashboardApiService.getCounters().pipe(take(1)).subscribe()
         
          resolve();
        },
        error: (err)=> {
          resolve()
        }

      });
    })
  }

  private _checkPremiumTime(response: APIResponse): void {
    if (!response.success || !response.data?.subscription?.subscriptionCurrentPeriodEnd) {
      return;
    }

   const premiumDays = Utils.checkSubscriptionDays(response.data?.subscription)
    
    console.log(`[AppInitService]: Plan days left: ${premiumDays}`);

    if (premiumDays > 0) {
      return;
    }

    console.log(`[AppInitService]: No premium days left. Redirecting...`);
    const translatedPath = '/account/my-account/subscription/expired';
    this._router.navigate([translatedPath]);
  }
}
